module.exports = __webpack_public_path__ + "img/icon_2_20.3bed768f.png";